angular.module('gym.invoices').factory('SkipInvoiceService', ["$rootScope", "$http", "$filter", "$q", "MessageService", "flash", "loadingAnimation", function($rootScope, $http, $filter, $q, MessageService, flash, loadingAnimation) {
  return {
    skip: function(invoice) {
      var creditAmount, deferred, gym, message;
      deferred = $q.defer();
      gym = $rootScope.gym;
      message = ['Are you sure you want to skip this invoice?'];
      if (+invoice.credit_applied_amount) {
        creditAmount = $filter('currency')(invoice.credit_applied_amount, gym.currency_symbol);
        message.push(`Note: ${creditAmount} credit was previously applied to this payment. If you wish to remove this credit, please do so from the payment actions menu.`);
      }
      MessageService.message({
        title: 'Skip invoice',
        message: message,
        confirmButtonText: "Yes"
      }).then(function() {
        var url;
        loadingAnimation.show();
        url = `/gyms/${gym.id}/invoices/${invoice.id}`;
        return $http.put(url, {
          invoice: {
            skip: true
          }
        }).then(function() {
          flash.success = 'Invoice marked as skipped';
          loadingAnimation.hide();
          return deferred.resolve();
        }, function(error) {
          if (error.data.error_message) {
            flash.error = error.data.error_message;
            loadingAnimation.hide();
          } else {
            flash.error = "There was an error processing the request.";
            loadingAnimation.hide();
          }
          return deferred.reject();
        });
      });
      return deferred.promise;
    }
  };
}]);
